export const LanguageMapping = new Map<string, string>([
    ['zh-cn', 'CHINESE'],
    ['zh-tw', 'CHINESE_TRADITIONAL'],
    ['ja', 'JAPANESE'],
    ['en', 'ENGLISH'],
    ['de', 'GERMAN'],
]);

export const LanguageRegionMapping = new Map<string, [string, string]>([
    ['zh-cn', ['ASIA', 'CN']],
    ['zh-tw', ['ASIA', 'TW']],
    ['ja', ['ASIA', 'JP']],
    ['en', ['AMERICA', 'US']],
    ['de', ['EMEA', 'DE']],
]);
